import { instance, IResponse } from 'services';

import { IAuthToken, IBaseAuthentication } from './auth.types';

export const AuthResources = {
  auth: (auth: IBaseAuthentication): IResponse<IAuthToken> =>
    instance.get('/tokens/jwt', { auth }),
};
